import { render, staticRenderFns } from "./InjurySentSummary.vue?vue&type=template&id=03160d86&scoped=true"
import script from "./InjurySentSummary.vue?vue&type=script&lang=js"
export * from "./InjurySentSummary.vue?vue&type=script&lang=js"
import style0 from "./InjurySentSummary.vue?vue&type=style&index=0&id=03160d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03160d86",
  null
  
)

export default component.exports